import { setPostRequestParams } from 'utilities/http';

function init () {

	window.initFormValidation(true, '.footerSubscribe form');

	const container = document.querySelector('.dyEmailSubscribe');
	const form = container.querySelector('form');
	const submitBtn = document.getElementById('dyEmailSubscribeSubmitBtn');

	const showSuccessMessage = (alreadySubscribed) => {

		form.remove();
		const message = container.querySelector('.dyEmailSubscribe__message');

		if (alreadySubscribed) {

			message.innerText = 'This email address is already subscribed';

		} else {

			message.innerHTML = '<strong>Thank You</strong> <br/>You are now subscribed.';

		}

		container.querySelector('.dyEmailSubscribe__success').classList.remove('hidden');

	};

	// Footer email sign up functionality
	$('#dyEmailSubscribeSubmitBtn').on('click', async (e) => {

		if ($(form).valid()) {

			const objEmail = $('#textEmailUpdatesRequest').val();

			if (objEmail !== null) {

				const email = objEmail.replace(/</g, '').replace(/>/g, '');
				if (email.length > 0) {

					if (e) {

						e.preventDefault();

					}

					const email = form.dataset.submittedEmail || form.querySelector('input.email').value;
					const data = { EmailAddress: email };

					try {

						if (submitBtn) {

							submitBtn.setAttribute('aria-disabled', true);

						}

						const fetched = await fetch(
							'/account/emailinline/',
							setPostRequestParams({ data, headers: { 'Content-Type': 'application/json' } })
						);
						const result = await fetched.json();

						// Email already has an account, redirect to sign in
						if (result.AccountExists) {

							window.location =								'/account/sign-in/?errormessage=UserAccountAlreadyExist&ReturnUrl=EmailPreference';
							return;

						}

						// Already subscribed to receive emails
						if (result.ProfileExists) {

							showSuccessMessage(true);
							return;

						}

						// Successfully subscribed
						if (result.SubscribeNowThankYou) {

							showSuccessMessage();

						}

						// Unsuccessful, re-enable button
						if (submitBtn) {

							submitBtn.setAttribute('aria-disabled', false);

						}

					} catch (err) {

						if (submitBtn) {

							submitBtn.setAttribute('aria-disabled', false);

						}

					}

				}

			}

		}

	});

	window.initFormValidation(true, form, {
		errorElement: 'span',
		success: 'valid'
	});

}

export default init;
